module.exports = __webpack_public_path__ + "img/block_bg_1.ab1fcf8a.png";